import crud from './helpers/crud';

const getShares = (recordId) => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_SHARES',
      fail: 'FAILED_GET_SHARES',
      end: 'FINISH_GET_SHARES',
    },
    method: 'GET',
    url: `/api/v1/records/${recordId}/shares`,
  })
);

const getSuggestions = (recordId) => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_SHARE_SUGGESTIONS',
      fail: 'FAILED_GET_SHARE_SUGGESTIONS',
      end: 'FINISH_GET_SHARE_SUGGESTIONS',
    },
    method: 'GET',
    url: `/api/v1/records/${recordId}/shares/suggestions`,
  })
);

const createShare = (recordId, externalPartnerId) => (
  crud({
    dispatch: {
      begin: 'BEGIN_CREATE_SHARE',
      fail: 'FAILED_CREATE_SHARE',
      end: 'FINISH_CREATE_SHARE',
    },
    method: 'POST',
    url: `/api/v1/records/${recordId}/shares`,
    data: { external_partner_id: externalPartnerId },
  })
);

const revokeShare = (recordId, shareId) => (
  crud({
    dispatch: {
      begin: 'BEGIN_REVOKE_SHARE',
      fail: 'FAILED_REVOKE_SHARE',
      end: 'FINISH_REVOKE_SHARE',
    },
    method: 'DELETE',
    url: `/api/v1/records/${recordId}/shares/${shareId}`,
  })
);

const selectPartner = (partnerId) => (dispatch) => {
  dispatch({
    type: 'SELECT_SHARE_PARTNER',
    partnerId,
  });
};

const clearShareState = () => (dispatch) => {
  dispatch({
    type: 'CLEAR_SHARE_STATE',
  });
};

export {
  getShares,
  getSuggestions,
  createShare,
  revokeShare,
  selectPartner,
  clearShareState,
};
